import NanoEvents from "nanoevents";
import {
  AddQueueReturnType,
  EventTypes,
  FetchMethod,
  FetchQueueReducer,
  FetchingKeys,
  Item,
  OnFetching,
  OnUpdateList,
  QueuePoolState,
  Queues,
  addQueueType,
} from "./types";
import { Queue } from "./queue";

const UPDATE_LIST_EVENT = "updateList";
const FETCHING_EVENT = "fetching";

const emitter: NanoEvents<{
  [key: string]: Record<string, any>;
}> = new NanoEvents();

export function fireUpdateListEvent(queueName: string, items: Item[], eventType: EventTypes): void {
  emitter.emit(UPDATE_LIST_EVENT, { eventType, items, queueName });
}

export function fireFetchingEvent(queueName: string, fetchingKeys: FetchingKeys): void {
  emitter.emit(FETCHING_EVENT, { fetchingKeys, queueName });
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function QueuePool() {
  const queuePool: Queues = {};
  let initItems: FetchQueueReducer = {};

  function onUpdateList(cb: OnUpdateList): ReturnType<typeof emitter.on> {
    return emitter.on.apply(emitter, [UPDATE_LIST_EVENT, cb]);
  }

  function onFetching(cb: OnFetching): ReturnType<typeof emitter.on> {
    return emitter.on.apply(emitter, [FETCHING_EVENT, cb]);
  }

  function addQueue(queueName: string, fetchMethod: FetchMethod, initItem?: Item[]): { addQueue: addQueueType } {
    const init = initItem || initItems[queueName];
    queuePool[queueName] = Queue(queueName, fetchMethod, init);

    return Object.freeze({
      addQueue: addQueue as addQueueType,
    }) as AddQueueReturnType;
  }

  function initPool(userId: number, pool: QueuePoolState): { addQueue: addQueueType } {
    initItems = pool && typeof pool[userId] === "object" ? { ...pool[userId] } : {};

    return Object.freeze({
      addQueue: addQueue as addQueueType,
    }) as AddQueueReturnType;
  }

  function getQueues(): Queues {
    return queuePool;
  }

  function getQueue(queueName: string): ReturnType<typeof Queue> {
    return queuePool[queueName];
  }

  function removeQueue(queueName: string): void {
    if (queuePool[queueName]) {
      queuePool[queueName].removeInterval();
      delete queuePool[queueName];
    }
  }

  return Object.freeze({
    addQueue,
    getQueue,
    getQueues,
    initPool,
    onFetching,
    onUpdateList,
    removeQueue,
  });
}
